import Base from '@/models/base.model.js';
import Company from '@/models/company.model.js';
import Lunch from '@/models/lunch.model.js';
import Rates from '@/models/rates.model.js';
import { $ERROR, $Error } from '@utils/error';
import moment from 'moment';

export const OFFER_STATUS = Object.freeze({
	OPEN: 'open',
	CANCELLED: 'cancelled',
	REQUESTED: 'requested',
	CONFIRMED: 'confirmed',
	PARTIAL_CONFIRMED: 'partially-confirmed',
});

export const OFFER_REQUEST_STATUS = Object.freeze({
	OPEN: 'open',
	CANCELLED: 'cancelled',
	REJECTED: 'rejected',
	REQUESTED: 'requested',
	CONFIRMED: 'confirmed',
	PARTIAL_CONFIRMED: 'partially-confirmed',
});

export const OFFER_TYPES = Object.freeze({
	PUBLIC: 'public',
	PRIVATE: 'private',
});

const DATE_FORMAT = 'YYYY-MM-DD';

export class Offer extends Base {
	constructor(obj) {
		super(obj);
		if (!obj) return;

		this.experience = obj.experience;
		this.isdeleted = obj.isdeleted;
		this.end_date = obj.end_date;
		this.status = obj.status;
		this.createdAt = obj.createdAt;
		this.isactive = obj.isactive;
		this.start_time = obj.start_time;
		this.end_time = obj.end_time;
		this.createdBy = obj.createdBy;
		this.offer_code = obj.offer_code;
		this.date = obj.date;
		this.notes = obj.notes;
		this.offer_type = obj.offer_type;
		this.rates = obj.rates;
		this.profession = obj.profession;
		this.available_dates = obj.available_dates;
		this.practice_region = obj.practice_region;
		this.profession = obj.profession;
		this.company = new Company(obj.company);
		this.lunch = new Lunch(obj.lunch);
		this.skills = obj.skills;
		this.offers_requests = Array.isArray(obj.offers_requests) ? obj.offers_requests.map(x => new OfferRequest(x)) : [new OfferRequest(obj.offers_requests)];
		this.request_dates = Array.isArray(obj.request_dates) ? obj.request_dates.map(x => new RequestDate(x)) : [];
	}

	static get STATUS() {
		return OFFER_STATUS;
	}

	static get TYPES() {
		return OFFER_TYPES;
	}

	static get DATE_FORMAT() {
		return DATE_FORMAT;
	}

	static sortByDate(offers) {
		if (!Array.isArray(offers)) throw $Error($ERROR.ERR_TYPE);
		offers.sort((a, b) => new moment(a.date) - new moment(b.date));
	}
}

export class OfferRequest extends Base {
	constructor(obj) {
		super(obj);
		if (!obj) return;

		this.profession = obj.profession;
		this.qualifications = obj.qualifications;
		this.booking_dates = obj.booking_dates;
		this.uniqueAppReference = obj.uniqueAppReference;
		this.surname = obj.surname;
		this.contact = obj.contact;
		this.rates = new Rates(obj.rates);
		this.name = obj.name;
		this.status = obj.status;
		this.status_reason = obj.status_reason;
		this.email = obj.email;
	}

	static get STATUS() {
		return OFFER_REQUEST_STATUS;
	}
}
class RequestDate extends Base {
	constructor(obj) {
		super(obj);
		if (!obj) return;

		this.date = obj.date;
		this.start_time = obj.start_time;
		this.end_time = obj.end_time;
	}
}

export default Offer;
